import script from "./DeveloperStories.vue?vue&type=script&setup=true&lang=js"
export * from "./DeveloperStories.vue?vue&type=script&setup=true&lang=js"

import "./DeveloperStories.vue?vue&type=style&index=0&id=16c5b9c0&lang=css"

const __exports__ = script;

export default __exports__